export const mockResponses = {
  'Member.LoadMemberDetail': {
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 0,
    "Result": {
      "Data": {
        "Id": 1772080,
        "AccountId": "5ecaf32892a248caba0c622a22c5448e",
        "PhotoUrl": "[{\"FileId\":-2,\"FilePath\":\"https://thirdwx.qlogo.cn/mmopen/vi_32/xzqOtP5jShSqGYYwTFENXIYawNFonykfpMEcFm658mmxQrsUB6iaGV0NSBCm9BiaZibJvfoVDMiceJ4ZWIZ7g9mtfQ/132\",\"FileName\":null,\"FileExt\":null,\"ServerUrl\":\"https://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
        "Phone": "13682229829",
        "MemberName": "周穗庭",
        "NickName": "周穗庭",
        "Email": null,
        "AddDate": "0001-01-01 00:00:00",
        "Score": 26492,
        "Coins": 7010,
        "Level": 3,
        "LevelName": "银牌会员",
        "CardTag": "0"
      },
      "UnpayCounter": 999,
      "ShippingCounter": 2,
      "UnsignCounter": 3,
      "OrderCounter": 67,
      "CouponCounter": 14,
      "KFCCouponCounter": 0,
      "RedeemcodeCounter": 0,
      "RedPacakgeCounter": 0,
      "IsSign": false,
      "DiffScore": 3508,
      "NextLevel": "金牌会员",
      "TotalSignCount": 0,
      "VCradData": null,
      "IsShareUser": false,
      "IsMemberWake": false
    }
  },
'Member.LoadMemberCouponList': {
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 14,
    "Result": {
        "TicketList": [
            {
                "RedirectUrl": "",
                "Amount": 8.0,
                "OrderMinAmount": 1,
                "TicketCode": "330f840214d1470fb579932e42a83d2e",
                "Title": "年终大促大转盘满88减8优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 10:00:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促大转盘满88减8优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 8.0,
                "OrderMinAmount": 1,
                "TicketCode": "53e49a3b0f154dc59fbc9b389763af00",
                "Title": "年终大促大转盘满88减8优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 10:00:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促大转盘满88减8优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 20.0,
                "OrderMinAmount": 200,
                "TicketCode": "a8a22938e0414f9d83a6926d5f6c8c51",
                "Title": "年终大促满200减20优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 09:45:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促满200减20优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 12.0,
                "OrderMinAmount": 120,
                "TicketCode": "1ff7a4e219044545b5bb76379f7dada3",
                "Title": "年终大促满120减12优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 09:45:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促满120减12优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 5.0,
                "OrderMinAmount": 88,
                "TicketCode": "13d24e4a4002427eab22109e536a1384",
                "Title": "年终大促满88减5优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 09:45:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促满88减5优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 20.0,
                "OrderMinAmount": 200,
                "TicketCode": "30b872571d104ffba43a8b157bb32e13",
                "Title": "年终大促满200减20优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 09:45:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促满200减20优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 12.0,
                "OrderMinAmount": 120,
                "TicketCode": "d4d0d802202a4726b8787a96beb32a8f",
                "Title": "年终大促满120减12优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 09:45:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促满120减12优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 5.0,
                "OrderMinAmount": 88,
                "TicketCode": "16a9291a60bc48259982ac65d1001d15",
                "Title": "年终大促满88减5优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 09:45:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促满88减5优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 20.0,
                "OrderMinAmount": 200,
                "TicketCode": "2042a5d625b74e4db566c458567fcfc1",
                "Title": "年终大促满200减20优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 09:45:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促满200减20优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 12.0,
                "OrderMinAmount": 120,
                "TicketCode": "ece149093df9454ca6719468422771aa",
                "Title": "年终大促满120减12优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 09:45:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促满120减12优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 5.0,
                "OrderMinAmount": 88,
                "TicketCode": "5498c38b512947709c65e08c5f5097ae",
                "Title": "年终大促满88减5优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 09:45:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促满88减5优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 20.0,
                "OrderMinAmount": 200,
                "TicketCode": "65712e3fb6b1499e8bb675dce9450f0d",
                "Title": "年终大促满200减20优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 09:45:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促满200减20优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 12.0,
                "OrderMinAmount": 120,
                "TicketCode": "1ffbe61326454030b256e94fa2694fbe",
                "Title": "年终大促满120减12优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 09:45:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促满120减12优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            },
            {
                "RedirectUrl": "",
                "Amount": 5.0,
                "OrderMinAmount": 88,
                "TicketCode": "9b30516a573248cb92bfcd56c4037d5d",
                "Title": "年终大促满88减5优惠券",
                "ThumbnailImg": null,
                "ExchangeCode": null,
                "Status": "1",
                "StartTime": "2024-12-05 09:45:00",
                "EndTime": "2025-01-01 00:00:00",
                "Memo": "年终大促满88减5优惠券",
                "Type": 4,
                "ProductList": null,
                "VCardProductRate": 0.0
            }
        ]
    }
  },
'Member.LoadScoreLogList':{
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 163,
    "Result": {
        "List": [
            {
                "ID": 3723262,
                "REMARK": "签到成功，获得10积分",
                "SCORE": 10,
                "SCORE_TYPE": "signin",
                "RULE_TYPE": "score",
                "OPT_TIME": "2025-01-02 16:24:41"
            },
            {
                "ID": 3713440,
                "REMARK": "年终大促大转盘",
                "SCORE": 2000,
                "SCORE_TYPE": "score",
                "RULE_TYPE": "score",
                "OPT_TIME": "2024-12-12 17:17:17"
            },
            {
                "ID": 3713439,
                "REMARK": "年终大促大转盘",
                "SCORE": 5000,
                "SCORE_TYPE": "score",
                "RULE_TYPE": "score",
                "OPT_TIME": "2024-12-12 17:17:17"
            },
            {
                "ID": 3713332,
                "REMARK": "签到成功，获得10积分",
                "SCORE": 10,
                "SCORE_TYPE": "signin",
                "RULE_TYPE": "score",
                "OPT_TIME": "2024-12-12 10:49:03"
            },
            {
                "ID": 3690637,
                "REMARK": "抵消订单金额￥2.81,扣减积分1405",
                "SCORE": -1405,
                "SCORE_TYPE": "exchange_fee",
                "RULE_TYPE": "score",
                "OPT_TIME": "2024-10-21 19:01:49"
            },
            {
                "ID": 3604476,
                "REMARK": "签到成功，获得10积分",
                "SCORE": 10,
                "SCORE_TYPE": "signin",
                "RULE_TYPE": "score",
                "OPT_TIME": "2024-03-28 23:59:47"
            },
            {
                "ID": 3556176,
                "REMARK": "签到成功，获得10积分",
                "SCORE": 10,
                "SCORE_TYPE": "signin",
                "RULE_TYPE": "score",
                "OPT_TIME": "2023-12-22 10:33:06"
            },
            {
                "ID": 3540564,
                "REMARK": "签到成功，获得10积分",
                "SCORE": 10,
                "SCORE_TYPE": "signin",
                "RULE_TYPE": "score",
                "OPT_TIME": "2023-11-20 11:29:59"
            },
            {
                "ID": 3528751,
                "REMARK": "签到成功，获得10积分",
                "SCORE": 10,
                "SCORE_TYPE": "signin",
                "RULE_TYPE": "score",
                "OPT_TIME": "2023-11-01 13:25:02"
            },
            {
                "ID": 3490086,
                "REMARK": "完成订单，获得567积分，V卡V2会员1.5倍积分",
                "SCORE": 567,
                "SCORE_TYPE": "pay_order",
                "RULE_TYPE": "score",
                "OPT_TIME": "2023-07-30 04:00:06"
            },
            {
                "ID": 3477805,
                "REMARK": "完成订单，获得398积分，V卡V2会员1.5倍积分",
                "SCORE": 398,
                "SCORE_TYPE": "pay_order",
                "RULE_TYPE": "score",
                "OPT_TIME": "2023-07-02 04:00:05"
            },
            {
                "ID": 3477801,
                "REMARK": "完成订单，获得398积分，V卡V2会员1.5倍积分",
                "SCORE": 398,
                "SCORE_TYPE": "pay_order",
                "RULE_TYPE": "score",
                "OPT_TIME": "2023-07-02 04:00:05"
            },
            {
                "ID": 3476742,
                "REMARK": "抵消订单金额￥20.39,扣减积分10195",
                "SCORE": -10195,
                "SCORE_TYPE": "exchange_fee",
                "RULE_TYPE": "score",
                "OPT_TIME": "2023-06-29 15:15:17"
            },
            {
                "ID": 3459362,
                "REMARK": "签到成功，获得10积分",
                "SCORE": 10,
                "SCORE_TYPE": "signin",
                "RULE_TYPE": "score",
                "OPT_TIME": "2023-05-29 12:12:04"
            },
            {
                "ID": 3459361,
                "REMARK": "活动赠送积分",
                "SCORE": 100,
                "SCORE_TYPE": "score",
                "RULE_TYPE": "score",
                "OPT_TIME": "2023-05-29 12:11:47"
            }
        ]
    }
  },
'Member.LoadOrderList': {
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 147,
    "Result": {
        "List": [
            {
                "Id": 1637062,
                "OrderNo": "241214124315121471500",
                "PaymentNo": "241214124315121471500_NATIVE",
                "PaymentTradeNo": null,
                "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
                "MemberName": null,
                "Phone": null,
                "DeleteStatus": "0",
                "CancelStatus": 0,
                "PayStatus": 0,
                "ShippingStatus": -9,
                "ShippingNo": null,
                "ShippingType": null,
                "FinishedStatus": 0,
                "ConfirmedStatus": 0,
                "CommentStatus": "0",
                "OrderTime": "2024-12-14 12:43:15",
                "TotalPrice": 55.00,
                "PaymentPrice": 55.00,
                "PaymentId": 3,
                "PaymentName": "WXPAY",
                "PaymentInterface": "微信支付",
                "ReceiverName": "周",
                "ReceiverPhone": "13682229829",
                "ReceiverProvince": "广东省",
                "ReceiverCity": "广州市",
                "ReceiverAddress": "越秀区麓苑路51号三荣大厦商务中心413",
                "Remark": "",
                "Kind": "shop",
                "ShipPrice": 0.00,
                "ReceiverPostalCode": 0.0,
                "OrderActions": null,
                "PackageStatus": 0,
                "ProductList": [
                    {
                        "ProductSkuNo": "112515762901_28456_",
                        "SkuParamCode": "[{\"GroupId\":10562,\"GroupName\":\"规格\",\"ItemId\":28456,\"ItemName\":\"001意式灰粉\"}]",
                        "Counter": 1,
                        "TotalPrice": 59.00,
                        "Kind": "shop",
                        "DeptCode": null,
                        "Remark": null,
                        "IsSpecaillyPrice": -1,
                        "UseDiscount": 0.0,
                        "IsHaveVCardPromotion": false,
                        "ShippingConfig": null,
                        "ShippingFee": 0.0,
                        "XinglianMinimumQty": null,
                        "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"/res/gdtvimg/20241121/9b90502baec641d18baed73bba0e401d.jpg\",\"FileName\":null,\"FileExt\":\"jpg\",\"ServerUrl\":\"https://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
                        "ProductName": "C&C时尚轻奢感羊羔绒围巾",
                        "ProductNameTag": null,
                        "ProductNo": "112515762901",
                        "IsForSale": null,
                        "ShortDesc": "秋冬百搭披肩双面可戴 礼盒装送礼佳品",
                        "ShortDescTag": null,
                        "SalePrice": 59.00,
                        "MarketPrice": 0.0,
                        "GroundingTime": "0001-01-01 00:00:00",
                        "Storage": 0,
                        "StorageStatus": 0,
                        "StartTime": null,
                        "EndTime": null,
                        "SellCount": 0,
                        "Status": null,
                        "IsVirtual": null,
                        "RemarkConfig": null,
                        "StoreId": 0,
                        "PackContent": null,
                        "GiftContent": null,
                        "TagIds": null,
                        "TagKind": null,
                        "IsShow": null,
                        "Video": null,
                        "TypePrefixStr": null,
                        "TypeId": 0,
                        "LimitConfig": null,
                        "Memo": null,
                        "FakeSellCount": 0,
                        "UpdateTime": "0001-01-01 00:00:00",
                        "IsRestrictBuy": null,
                        "CookBookList": null,
                        "IsFreeSample": null
                    }
                ],
                "PackageList": null,
                "GiftList": null,
                "SplitStatus": 0,
                "DiscountFee": 4.00,
                "ProducctFee": 59.00,
                "AppendStatus": "0",
                "DeptCode": "",
                "IsVirtual": false,
                "CanAfterSale": false
            },
            {
                "Id": 1637061,
                "OrderNo": "241214124155121471400",
                "PaymentNo": "241214124155121471400_NATIVE",
                "PaymentTradeNo": null,
                "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
                "MemberName": null,
                "Phone": null,
                "DeleteStatus": "0",
                "CancelStatus": 1,
                "PayStatus": 0,
                "ShippingStatus": -9,
                "ShippingNo": null,
                "ShippingType": null,
                "FinishedStatus": 0,
                "ConfirmedStatus": 0,
                "CommentStatus": "0",
                "OrderTime": "2024-12-14 12:41:55",
                "TotalPrice": 220.00,
                "PaymentPrice": 220.00,
                "PaymentId": 3,
                "PaymentName": "WXPAY",
                "PaymentInterface": "微信支付",
                "ReceiverName": "周",
                "ReceiverPhone": "13682229829",
                "ReceiverProvince": "广东省",
                "ReceiverCity": "广州市",
                "ReceiverAddress": "越秀区麓苑路51号三荣大厦商务中心413",
                "Remark": "",
                "Kind": "shop",
                "ShipPrice": 0.00,
                "ReceiverPostalCode": 0.0,
                "OrderActions": null,
                "PackageStatus": 0,
                "ProductList": [
                    {
                        "ProductSkuNo": "112515762901_28456_",
                        "SkuParamCode": "[{\"GroupId\":10562,\"GroupName\":\"规格\",\"ItemId\":28456,\"ItemName\":\"001意式灰粉\"}]",
                        "Counter": 4,
                        "TotalPrice": 236.00,
                        "Kind": "shop",
                        "DeptCode": null,
                        "Remark": null,
                        "IsSpecaillyPrice": -1,
                        "UseDiscount": 0.0,
                        "IsHaveVCardPromotion": false,
                        "ShippingConfig": null,
                        "ShippingFee": 0.0,
                        "XinglianMinimumQty": null,
                        "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"/res/gdtvimg/20241121/9b90502baec641d18baed73bba0e401d.jpg\",\"FileName\":null,\"FileExt\":\"jpg\",\"ServerUrl\":\"https://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
                        "ProductName": "C&C时尚轻奢感羊羔绒围巾",
                        "ProductNameTag": null,
                        "ProductNo": "112515762901",
                        "IsForSale": null,
                        "ShortDesc": "秋冬百搭披肩双面可戴 礼盒装送礼佳品",
                        "ShortDescTag": null,
                        "SalePrice": 59.00,
                        "MarketPrice": 0.0,
                        "GroundingTime": "0001-01-01 00:00:00",
                        "Storage": 0,
                        "StorageStatus": 0,
                        "StartTime": null,
                        "EndTime": null,
                        "SellCount": 0,
                        "Status": null,
                        "IsVirtual": null,
                        "RemarkConfig": null,
                        "StoreId": 0,
                        "PackContent": null,
                        "GiftContent": null,
                        "TagIds": null,
                        "TagKind": null,
                        "IsShow": null,
                        "Video": null,
                        "TypePrefixStr": null,
                        "TypeId": 0,
                        "LimitConfig": null,
                        "Memo": null,
                        "FakeSellCount": 0,
                        "UpdateTime": "0001-01-01 00:00:00",
                        "IsRestrictBuy": null,
                        "CookBookList": null,
                        "IsFreeSample": null
                    }
                ],
                "PackageList": null,
                "GiftList": null,
                "SplitStatus": 0,
                "DiscountFee": 16.00,
                "ProducctFee": 236.00,
                "AppendStatus": "0",
                "DeptCode": "",
                "IsVirtual": false,
                "CanAfterSale": false
            },
            {
                "Id": 1634286,
                "OrderNo": "241021211849121238100",
                "PaymentNo": "241021211849121238100",
                "PaymentTradeNo": null,
                "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
                "MemberName": null,
                "Phone": null,
                "DeleteStatus": "0",
                "CancelStatus": 1,
                "PayStatus": 0,
                "ShippingStatus": -9,
                "ShippingNo": null,
                "ShippingType": null,
                "FinishedStatus": 0,
                "ConfirmedStatus": 0,
                "CommentStatus": "0",
                "OrderTime": "2024-10-21 21:18:49",
                "TotalPrice": 38.80,
                "PaymentPrice": 38.80,
                "PaymentId": 6,
                "PaymentName": "WXPAY",
                "PaymentInterface": "微信支付",
                "ReceiverName": "周",
                "ReceiverPhone": "13682229829",
                "ReceiverProvince": "广东省",
                "ReceiverCity": "广州市",
                "ReceiverAddress": "越秀区麓苑路51号三荣大厦商务中心413",
                "Remark": "",
                "Kind": "shop",
                "ShipPrice": 0.00,
                "ReceiverPostalCode": 0.0,
                "OrderActions": null,
                "PackageStatus": 0,
                "ProductList": [
                    {
                        "ProductSkuNo": "082019763901_27208_",
                        "SkuParamCode": "[{\"GroupId\":10058,\"GroupName\":\"广西荔浦芋头 精品大果\",\"ItemId\":27208,\"ItemName\":\"尝鲜价 3斤净重大果\"}]",
                        "Counter": 1,
                        "TotalPrice": 38.80,
                        "Kind": "shop",
                        "DeptCode": null,
                        "Remark": null,
                        "IsSpecaillyPrice": -1,
                        "UseDiscount": 0.0,
                        "IsHaveVCardPromotion": false,
                        "ShippingConfig": null,
                        "ShippingFee": 0.0,
                        "XinglianMinimumQty": null,
                        "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"https://scce-cos-prd.obs.cn-south-1.myhuaweicloud.com:443/b0f6fd322dc746798621b475d039b8a2.jpg?a=\",\"FileName\":null,\"FileExt\":\"jpg\",\"ServerUrl\":\"\",\"SplitList\":null}]",
                        "ProductName": "广西荔浦芋头  精品果（非电商果） 软糯香甜 3/5/9斤  包邮",
                        "ProductNameTag": null,
                        "ProductNo": "082019763901",
                        "IsForSale": null,
                        "ShortDesc": null,
                        "ShortDescTag": null,
                        "SalePrice": 38.80,
                        "MarketPrice": 0.0,
                        "GroundingTime": "0001-01-01 00:00:00",
                        "Storage": 0,
                        "StorageStatus": 0,
                        "StartTime": null,
                        "EndTime": null,
                        "SellCount": 0,
                        "Status": null,
                        "IsVirtual": null,
                        "RemarkConfig": null,
                        "StoreId": 0,
                        "PackContent": null,
                        "GiftContent": null,
                        "TagIds": null,
                        "TagKind": null,
                        "IsShow": null,
                        "Video": null,
                        "TypePrefixStr": null,
                        "TypeId": 0,
                        "LimitConfig": null,
                        "Memo": null,
                        "FakeSellCount": 0,
                        "UpdateTime": "0001-01-01 00:00:00",
                        "IsRestrictBuy": null,
                        "CookBookList": null,
                        "IsFreeSample": null
                    }
                ],
                "PackageList": null,
                "GiftList": null,
                "SplitStatus": 0,
                "DiscountFee": 0.00,
                "ProducctFee": 38.80,
                "AppendStatus": "0",
                "DeptCode": "",
                "IsVirtual": false,
                "CanAfterSale": false
            },
            {
                "Id": 1634285,
                "OrderNo": "241021210925121238000",
                "PaymentNo": "241021210925121238000",
                "PaymentTradeNo": null,
                "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
                "MemberName": null,
                "Phone": null,
                "DeleteStatus": "0",
                "CancelStatus": 1,
                "PayStatus": 0,
                "ShippingStatus": -9,
                "ShippingNo": null,
                "ShippingType": null,
                "FinishedStatus": 0,
                "ConfirmedStatus": 0,
                "CommentStatus": "0",
                "OrderTime": "2024-10-21 21:09:25",
                "TotalPrice": 23.90,
                "PaymentPrice": 23.90,
                "PaymentId": 6,
                "PaymentName": "WXPAY",
                "PaymentInterface": "微信支付",
                "ReceiverName": "周",
                "ReceiverPhone": "13682229829",
                "ReceiverProvince": "广东省",
                "ReceiverCity": "广州市",
                "ReceiverAddress": "越秀区麓苑路51号三荣大厦商务中心413",
                "Remark": "",
                "Kind": "shop",
                "ShipPrice": 0.00,
                "ReceiverPostalCode": 0.0,
                "OrderActions": null,
                "PackageStatus": 0,
                "ProductList": [
                    {
                        "ProductSkuNo": "062119768002_26480_",
                        "SkuParamCode": "[{\"GroupId\":9747,\"GroupName\":\"规格\",\"ItemId\":26480,\"ItemName\":\"蟹黄酱100g*5罐\"}]",
                        "Counter": 1,
                        "TotalPrice": 23.90,
                        "Kind": "shop",
                        "DeptCode": null,
                        "Remark": null,
                        "IsSpecaillyPrice": -1,
                        "UseDiscount": 0.0,
                        "IsHaveVCardPromotion": false,
                        "ShippingConfig": null,
                        "ShippingFee": 0.0,
                        "XinglianMinimumQty": null,
                        "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"https://scce-cos-prd.obs.cn-south-1.myhuaweicloud.com:443/cab889124ed047fb964406d8d622e8ff.jpg?a=\",\"FileName\":null,\"FileExt\":\"jpg\",\"ServerUrl\":\"\",\"SplitList\":null}]",
                        "ProductName": "【鲜捕头】蟹黄酱  鲜香四溢 地道美味 真材实料100g*5罐",
                        "ProductNameTag": null,
                        "ProductNo": "062119768002",
                        "IsForSale": null,
                        "ShortDesc": null,
                        "ShortDescTag": null,
                        "SalePrice": 23.90,
                        "MarketPrice": 0.0,
                        "GroundingTime": "0001-01-01 00:00:00",
                        "Storage": 0,
                        "StorageStatus": 0,
                        "StartTime": null,
                        "EndTime": null,
                        "SellCount": 0,
                        "Status": null,
                        "IsVirtual": null,
                        "RemarkConfig": null,
                        "StoreId": 0,
                        "PackContent": null,
                        "GiftContent": null,
                        "TagIds": null,
                        "TagKind": null,
                        "IsShow": null,
                        "Video": null,
                        "TypePrefixStr": null,
                        "TypeId": 0,
                        "LimitConfig": null,
                        "Memo": null,
                        "FakeSellCount": 0,
                        "UpdateTime": "0001-01-01 00:00:00",
                        "IsRestrictBuy": null,
                        "CookBookList": null,
                        "IsFreeSample": null
                    }
                ],
                "PackageList": null,
                "GiftList": null,
                "SplitStatus": 0,
                "DiscountFee": 0.00,
                "ProducctFee": 23.90,
                "AppendStatus": "0",
                "DeptCode": "",
                "IsVirtual": false,
                "CanAfterSale": false
            },
            {
                "Id": 1634276,
                "OrderNo": "241021195323121237600",
                "PaymentNo": "241021195323121237600",
                "PaymentTradeNo": null,
                "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
                "MemberName": null,
                "Phone": null,
                "DeleteStatus": "0",
                "CancelStatus": 1,
                "PayStatus": 0,
                "ShippingStatus": -9,
                "ShippingNo": null,
                "ShippingType": null,
                "FinishedStatus": 0,
                "ConfirmedStatus": 0,
                "CommentStatus": "0",
                "OrderTime": "2024-10-21 19:53:23",
                "TotalPrice": 49.90,
                "PaymentPrice": 49.90,
                "PaymentId": 6,
                "PaymentName": "WXPAY",
                "PaymentInterface": "微信支付",
                "ReceiverName": "周",
                "ReceiverPhone": "13682229829",
                "ReceiverProvince": "广东省",
                "ReceiverCity": "广州市",
                "ReceiverAddress": "越秀区麓苑路51号三荣大厦商务中心413",
                "Remark": "",
                "Kind": "shop",
                "ShipPrice": 0.00,
                "ReceiverPostalCode": 0.0,
                "OrderActions": null,
                "PackageStatus": 0,
                "ProductList": [
                    {
                        "ProductSkuNo": "110813045901_22877_",
                        "SkuParamCode": "[{\"GroupId\":8033,\"GroupName\":\"规格\",\"ItemId\":22877,\"ItemName\":\"9斤\"}]",
                        "Counter": 1,
                        "TotalPrice": 49.90,
                        "Kind": "shop",
                        "DeptCode": null,
                        "Remark": null,
                        "IsSpecaillyPrice": -1,
                        "UseDiscount": 0.0,
                        "IsHaveVCardPromotion": false,
                        "ShippingConfig": null,
                        "ShippingFee": 0.0,
                        "XinglianMinimumQty": null,
                        "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"/res/gdtvimg/20231106/6f0ddaa48e9749bb90153f4dea9e5fd1.jpg\",\"FileName\":null,\"FileExt\":\"jpg\",\"ServerUrl\":\"https://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
                        "ProductName": "安江冰糖柚【9斤装】",
                        "ProductNameTag": null,
                        "ProductNo": "110813045901",
                        "IsForSale": null,
                        "ShortDesc": "果大、皮薄、肉嫩、汁多、味甜，深受广大消费者喜爱",
                        "ShortDescTag": null,
                        "SalePrice": 49.90,
                        "MarketPrice": 0.0,
                        "GroundingTime": "0001-01-01 00:00:00",
                        "Storage": 0,
                        "StorageStatus": 0,
                        "StartTime": null,
                        "EndTime": null,
                        "SellCount": 0,
                        "Status": null,
                        "IsVirtual": null,
                        "RemarkConfig": null,
                        "StoreId": 0,
                        "PackContent": null,
                        "GiftContent": null,
                        "TagIds": null,
                        "TagKind": null,
                        "IsShow": null,
                        "Video": null,
                        "TypePrefixStr": null,
                        "TypeId": 0,
                        "LimitConfig": null,
                        "Memo": null,
                        "FakeSellCount": 0,
                        "UpdateTime": "0001-01-01 00:00:00",
                        "IsRestrictBuy": null,
                        "CookBookList": null,
                        "IsFreeSample": null
                    }
                ],
                "PackageList": null,
                "GiftList": null,
                "SplitStatus": 0,
                "DiscountFee": 0.00,
                "ProducctFee": 49.90,
                "AppendStatus": "0",
                "DeptCode": "",
                "IsVirtual": false,
                "CanAfterSale": false
            },
            {
                "Id": 1634275,
                "OrderNo": "241021195256121237500",
                "PaymentNo": "241021195256121237500",
                "PaymentTradeNo": null,
                "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
                "MemberName": null,
                "Phone": null,
                "DeleteStatus": "0",
                "CancelStatus": 1,
                "PayStatus": 0,
                "ShippingStatus": -9,
                "ShippingNo": null,
                "ShippingType": null,
                "FinishedStatus": 0,
                "ConfirmedStatus": 0,
                "CommentStatus": "0",
                "OrderTime": "2024-10-21 19:52:56",
                "TotalPrice": 187.00,
                "PaymentPrice": 187.00,
                "PaymentId": 6,
                "PaymentName": "WXPAY",
                "PaymentInterface": "微信支付",
                "ReceiverName": "周",
                "ReceiverPhone": "13682229829",
                "ReceiverProvince": "广东省",
                "ReceiverCity": "广州市",
                "ReceiverAddress": "越秀区麓苑路51号三荣大厦商务中心413",
                "Remark": "",
                "Kind": "shop",
                "ShipPrice": 0.00,
                "ReceiverPostalCode": 0.0,
                "OrderActions": null,
                "PackageStatus": 0,
                "ProductList": [
                    {
                        "ProductSkuNo": "102511469201_8243_8246_",
                        "SkuParamCode": "[{\"GroupId\":387,\"GroupName\":\"规格\",\"ItemId\":8243,\"ItemName\":\"精品装3-4cm\"},{\"GroupId\":2510,\"GroupName\":\"重量\",\"ItemId\":8246,\"ItemName\":\"250g/盒\"}]",
                        "Counter": 1,
                        "TotalPrice": 199.00,
                        "Kind": "shop",
                        "DeptCode": null,
                        "Remark": null,
                        "IsSpecaillyPrice": -1,
                        "UseDiscount": 0.0,
                        "IsHaveVCardPromotion": false,
                        "ShippingConfig": null,
                        "ShippingFee": 0.0,
                        "XinglianMinimumQty": null,
                        "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"/res/gdtvimg/20171108/b72584e22f24454ba28fc85e0c3e6618.jpg\",\"FileName\":null,\"FileExt\":\"jpg\",\"ServerUrl\":\"http://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
                        "ProductName": "四川 鲜黑松露 精品装",
                        "ProductNameTag": null,
                        "ProductNo": "102511469201",
                        "IsForSale": null,
                        "ShortDesc": "鲜黑松露是一种生长于地下的野生食用真菌",
                        "ShortDescTag": null,
                        "SalePrice": 199.00,
                        "MarketPrice": 0.0,
                        "GroundingTime": "0001-01-01 00:00:00",
                        "Storage": 0,
                        "StorageStatus": 0,
                        "StartTime": null,
                        "EndTime": null,
                        "SellCount": 0,
                        "Status": null,
                        "IsVirtual": null,
                        "RemarkConfig": null,
                        "StoreId": 0,
                        "PackContent": null,
                        "GiftContent": null,
                        "TagIds": null,
                        "TagKind": null,
                        "IsShow": null,
                        "Video": null,
                        "TypePrefixStr": null,
                        "TypeId": 0,
                        "LimitConfig": null,
                        "Memo": null,
                        "FakeSellCount": 0,
                        "UpdateTime": "0001-01-01 00:00:00",
                        "IsRestrictBuy": null,
                        "CookBookList": null,
                        "IsFreeSample": null
                    }
                ],
                "PackageList": null,
                "GiftList": null,
                "SplitStatus": 0,
                "DiscountFee": 12.00,
                "ProducctFee": 199.00,
                "AppendStatus": "0",
                "DeptCode": "",
                "IsVirtual": false,
                "CanAfterSale": false
            },
            {
                "Id": 1634274,
                "OrderNo": "241021195148121237400",
                "PaymentNo": "241021195148121237400_NATIVE",
                "PaymentTradeNo": null,
                "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
                "MemberName": null,
                "Phone": null,
                "DeleteStatus": "0",
                "CancelStatus": 1,
                "PayStatus": 0,
                "ShippingStatus": -9,
                "ShippingNo": null,
                "ShippingType": null,
                "FinishedStatus": 0,
                "ConfirmedStatus": 0,
                "CommentStatus": "0",
                "OrderTime": "2024-10-21 19:51:48",
                "TotalPrice": 39.90,
                "PaymentPrice": 39.90,
                "PaymentId": 3,
                "PaymentName": "WXPAY",
                "PaymentInterface": "微信支付",
                "ReceiverName": "周",
                "ReceiverPhone": "13682229829",
                "ReceiverProvince": "广东省",
                "ReceiverCity": "广州市",
                "ReceiverAddress": "越秀区麓苑路51号三荣大厦商务中心413",
                "Remark": "",
                "Kind": "shop",
                "ShipPrice": 0.00,
                "ReceiverPostalCode": 0.0,
                "OrderActions": null,
                "PackageStatus": 0,
                "ProductList": [
                    {
                        "ProductSkuNo": "051619769501_25983_25984_",
                        "SkuParamCode": "[{\"GroupId\":9574,\"GroupName\":\"规格\",\"ItemId\":25983,\"ItemName\":\"30g*10袋\"},{\"GroupId\":9575,\"GroupName\":\"口味\",\"ItemId\":25984,\"ItemName\":\"鳕鱼片+原味/藤椒鱿鱼丝+鱿鱼条\"}]",
                        "Counter": 1,
                        "TotalPrice": 39.90,
                        "Kind": "shop",
                        "DeptCode": null,
                        "Remark": null,
                        "IsSpecaillyPrice": -1,
                        "UseDiscount": 0.0,
                        "IsHaveVCardPromotion": false,
                        "ShippingConfig": null,
                        "ShippingFee": 0.0,
                        "XinglianMinimumQty": null,
                        "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"https://scce-cos-prd.obs.cn-south-1.myhuaweicloud.com:443/28e7256b5ee04ec48b764ce88ec1281c.png?a=\",\"FileName\":null,\"FileExt\":\"jpg\",\"ServerUrl\":\"\",\"SplitList\":null}]",
                        "ProductName": "【鲜捕头】藤椒鱿鱼丝+鳕鱼片+鱿鱼条 海鲜零食 即食 30g*10袋",
                        "ProductNameTag": null,
                        "ProductNo": "051619769501",
                        "IsForSale": null,
                        "ShortDesc": null,
                        "ShortDescTag": null,
                        "SalePrice": 39.90,
                        "MarketPrice": 0.0,
                        "GroundingTime": "0001-01-01 00:00:00",
                        "Storage": 0,
                        "StorageStatus": 0,
                        "StartTime": null,
                        "EndTime": null,
                        "SellCount": 0,
                        "Status": null,
                        "IsVirtual": null,
                        "RemarkConfig": null,
                        "StoreId": 0,
                        "PackContent": null,
                        "GiftContent": null,
                        "TagIds": null,
                        "TagKind": null,
                        "IsShow": null,
                        "Video": null,
                        "TypePrefixStr": null,
                        "TypeId": 0,
                        "LimitConfig": null,
                        "Memo": null,
                        "FakeSellCount": 0,
                        "UpdateTime": "0001-01-01 00:00:00",
                        "IsRestrictBuy": null,
                        "CookBookList": null,
                        "IsFreeSample": null
                    }
                ],
                "PackageList": null,
                "GiftList": null,
                "SplitStatus": 0,
                "DiscountFee": 0.00,
                "ProducctFee": 39.90,
                "AppendStatus": "0",
                "DeptCode": "",
                "IsVirtual": false,
                "CanAfterSale": false
            },
            {
                "Id": 1634273,
                "OrderNo": "241021195101121237300",
                "PaymentNo": "241021195101121237300_NATIVE",
                "PaymentTradeNo": null,
                "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
                "MemberName": null,
                "Phone": null,
                "DeleteStatus": "0",
                "CancelStatus": 1,
                "PayStatus": 0,
                "ShippingStatus": -9,
                "ShippingNo": null,
                "ShippingType": null,
                "FinishedStatus": 0,
                "ConfirmedStatus": 0,
                "CommentStatus": "0",
                "OrderTime": "2024-10-21 19:51:02",
                "TotalPrice": 34.80,
                "PaymentPrice": 34.80,
                "PaymentId": 3,
                "PaymentName": "WXPAY",
                "PaymentInterface": "微信支付",
                "ReceiverName": "周",
                "ReceiverPhone": "13682229829",
                "ReceiverProvince": "广东省",
                "ReceiverCity": "广州市",
                "ReceiverAddress": "越秀区麓苑路51号三荣大厦商务中心413",
                "Remark": "",
                "Kind": "shop",
                "ShipPrice": 0.00,
                "ReceiverPostalCode": 0.0,
                "OrderActions": null,
                "PackageStatus": 0,
                "ProductList": [
                    {
                        "ProductSkuNo": "042819769501_25700_",
                        "SkuParamCode": "[{\"GroupId\":9436,\"GroupName\":\"规格\",\"ItemId\":25700,\"ItemName\":\"5斤净重5-7个红色\"}]",
                        "Counter": 1,
                        "TotalPrice": 34.80,
                        "Kind": "shop",
                        "DeptCode": null,
                        "Remark": null,
                        "IsSpecaillyPrice": -1,
                        "UseDiscount": 0.0,
                        "IsHaveVCardPromotion": false,
                        "ShippingConfig": null,
                        "ShippingFee": 0.0,
                        "XinglianMinimumQty": null,
                        "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"https://scce-cos-prd.obs.cn-south-1.myhuaweicloud.com:443/8410b866c25d4289983b4ce7810f58f3.jpg?a=\",\"FileName\":null,\"FileExt\":\"jpg\",\"ServerUrl\":\"\",\"SplitList\":null}]",
                        "ProductName": "云南水果玉米",
                        "ProductNameTag": null,
                        "ProductNo": "042819769501",
                        "IsForSale": null,
                        "ShortDesc": null,
                        "ShortDescTag": null,
                        "SalePrice": 34.80,
                        "MarketPrice": 0.0,
                        "GroundingTime": "0001-01-01 00:00:00",
                        "Storage": 0,
                        "StorageStatus": 0,
                        "StartTime": null,
                        "EndTime": null,
                        "SellCount": 0,
                        "Status": null,
                        "IsVirtual": null,
                        "RemarkConfig": null,
                        "StoreId": 0,
                        "PackContent": null,
                        "GiftContent": null,
                        "TagIds": null,
                        "TagKind": null,
                        "IsShow": null,
                        "Video": null,
                        "TypePrefixStr": null,
                        "TypeId": 0,
                        "LimitConfig": null,
                        "Memo": null,
                        "FakeSellCount": 0,
                        "UpdateTime": "0001-01-01 00:00:00",
                        "IsRestrictBuy": null,
                        "CookBookList": null,
                        "IsFreeSample": null
                    }
                ],
                "PackageList": null,
                "GiftList": null,
                "SplitStatus": 0,
                "DiscountFee": 0.00,
                "ProducctFee": 34.80,
                "AppendStatus": "0",
                "DeptCode": "",
                "IsVirtual": false,
                "CanAfterSale": false
            },
            {
                "Id": 1634272,
                "OrderNo": "241021190145121237200",
                "PaymentNo": "241021190145121237200",
                "PaymentTradeNo": null,
                "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
                "MemberName": null,
                "Phone": null,
                "DeleteStatus": "0",
                "CancelStatus": 1,
                "PayStatus": 0,
                "ShippingStatus": -9,
                "ShippingNo": null,
                "ShippingType": null,
                "FinishedStatus": 0,
                "ConfirmedStatus": 0,
                "CommentStatus": "0",
                "OrderTime": "2024-10-21 19:01:46",
                "TotalPrice": 47.09,
                "PaymentPrice": 47.09,
                "PaymentId": 6,
                "PaymentName": "WXPAY",
                "PaymentInterface": "微信支付",
                "ReceiverName": "周",
                "ReceiverPhone": "13682229829",
                "ReceiverProvince": "广东省",
                "ReceiverCity": "广州市",
                "ReceiverAddress": "越秀区麓苑路51号三荣大厦商务中心413",
                "Remark": "",
                "Kind": "shop",
                "ShipPrice": 0.00,
                "ReceiverPostalCode": 0.0,
                "OrderActions": null,
                "PackageStatus": 0,
                "ProductList": [
                    {
                        "ProductSkuNo": "110813045901_22877_",
                        "SkuParamCode": "[{\"GroupId\":8033,\"GroupName\":\"规格\",\"ItemId\":22877,\"ItemName\":\"9斤\"}]",
                        "Counter": 1,
                        "TotalPrice": 49.90,
                        "Kind": "shop",
                        "DeptCode": null,
                        "Remark": null,
                        "IsSpecaillyPrice": -1,
                        "UseDiscount": 0.0,
                        "IsHaveVCardPromotion": false,
                        "ShippingConfig": null,
                        "ShippingFee": 0.0,
                        "XinglianMinimumQty": null,
                        "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"/res/gdtvimg/20231106/6f0ddaa48e9749bb90153f4dea9e5fd1.jpg\",\"FileName\":null,\"FileExt\":\"jpg\",\"ServerUrl\":\"https://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
                        "ProductName": "安江冰糖柚【9斤装】",
                        "ProductNameTag": null,
                        "ProductNo": "110813045901",
                        "IsForSale": null,
                        "ShortDesc": "果大、皮薄、肉嫩、汁多、味甜，深受广大消费者喜爱",
                        "ShortDescTag": null,
                        "SalePrice": 49.90,
                        "MarketPrice": 0.0,
                        "GroundingTime": "0001-01-01 00:00:00",
                        "Storage": 0,
                        "StorageStatus": 0,
                        "StartTime": null,
                        "EndTime": null,
                        "SellCount": 0,
                        "Status": null,
                        "IsVirtual": null,
                        "RemarkConfig": null,
                        "StoreId": 0,
                        "PackContent": null,
                        "GiftContent": null,
                        "TagIds": null,
                        "TagKind": null,
                        "IsShow": null,
                        "Video": null,
                        "TypePrefixStr": null,
                        "TypeId": 0,
                        "LimitConfig": null,
                        "Memo": null,
                        "FakeSellCount": 0,
                        "UpdateTime": "0001-01-01 00:00:00",
                        "IsRestrictBuy": null,
                        "CookBookList": null,
                        "IsFreeSample": null
                    }
                ],
                "PackageList": null,
                "GiftList": null,
                "SplitStatus": 0,
                "DiscountFee": 2.81,
                "ProducctFee": 49.90,
                "AppendStatus": "0",
                "DeptCode": "",
                "IsVirtual": false,
                "CanAfterSale": false
            },
            {
                "Id": 1604046,
                "OrderNo": "240222142314119858700",
                "PaymentNo": "240222142314119858700",
                "PaymentTradeNo": null,
                "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
                "MemberName": null,
                "Phone": null,
                "DeleteStatus": "0",
                "CancelStatus": 1,
                "PayStatus": 0,
                "ShippingStatus": -9,
                "ShippingNo": null,
                "ShippingType": null,
                "FinishedStatus": 0,
                "ConfirmedStatus": 0,
                "CommentStatus": "0",
                "OrderTime": "2024-02-22 14:23:14",
                "TotalPrice": 62.10,
                "PaymentPrice": 62.10,
                "PaymentId": 6,
                "PaymentName": "WXPAY",
                "PaymentInterface": "微信支付",
                "ReceiverName": "周",
                "ReceiverPhone": "13682229829",
                "ReceiverProvince": "广东省",
                "ReceiverCity": "广州市",
                "ReceiverAddress": "越秀区麓苑路51号三荣大厦商务中心413",
                "Remark": "",
                "Kind": "shop",
                "ShipPrice": 0.00,
                "ReceiverPostalCode": 0.0,
                "OrderActions": null,
                "PackageStatus": 0,
                "ProductList": [
                    {
                        "ProductSkuNo": "020413049402_16122_",
                        "SkuParamCode": "[{\"GroupId\":4968,\"GroupName\":\"规格\",\"ItemId\":16122,\"ItemName\":\"一箱装（30克*10瓶）\"}]",
                        "Counter": 1,
                        "TotalPrice": 69.00,
                        "Kind": "shop",
                        "DeptCode": null,
                        "Remark": null,
                        "IsSpecaillyPrice": -1,
                        "UseDiscount": 0.0,
                        "IsHaveVCardPromotion": false,
                        "ShippingConfig": null,
                        "ShippingFee": 0.0,
                        "XinglianMinimumQty": null,
                        "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"/res/gdtvimg/20230201/42d4a45aae7845d0bf5d63958b71555d.jpg\",\"FileName\":null,\"FileExt\":\"jpg\",\"ServerUrl\":\"https://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
                        "ProductName": "怀府街山药饮  30克*10瓶  三种口味",
                        "ProductNameTag": null,
                        "ProductNo": "020413049402",
                        "IsForSale": null,
                        "ShortDesc": "早餐一瓶红枣山药饮：润肠通便、利尿、美容养颜\n晚餐一瓶藜麦山药饮：藜麦和燕麦两种都是热量比较低，糖分不高的食物，是减肥人士比较合适的食物。此外作为高膳食纤维的食物，会比较好消化的。吃些藜麦还是很有好处的。\n【产品优势】开启山药便捷新形态，冷水，热水，冰水，都能冲饮。\n山药养胃1.0形态：鲜山药，蒸煮食用。\n山药养胃2.0形态：鲜山药切片，泡水或煲汤食用。\n山药养胃3.0形态：鲜山药切片、研磨成粉，灌装奶粉桶不方便携带。\n山药养胃4.0形态：不用蒸煮，不用等待，随时随地，健康、便捷。\n7斤鲜山药制作1斤山药",
                        "ShortDescTag": null,
                        "SalePrice": 69.00,
                        "MarketPrice": 0.0,
                        "GroundingTime": "0001-01-01 00:00:00",
                        "Storage": 0,
                        "StorageStatus": 0,
                        "StartTime": null,
                        "EndTime": null,
                        "SellCount": 0,
                        "Status": null,
                        "IsVirtual": null,
                        "RemarkConfig": null,
                        "StoreId": 0,
                        "PackContent": null,
                        "GiftContent": null,
                        "TagIds": null,
                        "TagKind": null,
                        "IsShow": null,
                        "Video": null,
                        "TypePrefixStr": null,
                        "TypeId": 0,
                        "LimitConfig": null,
                        "Memo": null,
                        "FakeSellCount": 0,
                        "UpdateTime": "0001-01-01 00:00:00",
                        "IsRestrictBuy": null,
                        "CookBookList": null,
                        "IsFreeSample": null
                    }
                ],
                "PackageList": null,
                "GiftList": null,
                "SplitStatus": 0,
                "DiscountFee": 6.90,
                "ProducctFee": 69.00,
                "AppendStatus": "0",
                "DeptCode": "",
                "IsVirtual": false,
                "CanAfterSale": false
            }
        ]
    }
    },
  'Member.LoadOrderDetail':{
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 0,
    "Result": {
        "Data": {
            "Id": 1638292,
            "OrderNo": "250106171927121588600",
            "PaymentNo": "250106171927121588600",
            "PaymentTradeNo": "4200002454202501066074921625",
            "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
            "MemberName": null,
            "Phone": null,
            "DeleteStatus": "0",
            "CancelStatus": 0,
            "PayStatus": 1,
            "ShippingStatus": 1,
            "ShippingNo": "13682229829",
            "ShippingType": "shentong",
            "FinishedStatus": 0,
            "ConfirmedStatus": 1,
            "CommentStatus": "0",
            "OrderTime": "2025-01-06 17:19:27",
            "TotalPrice": 0.01,
            "PaymentPrice": 0.01,
            "PaymentId": 3,
            "PaymentName": "WXPAY",
            "PaymentInterface": "微信支付",
            "ReceiverName": "周",
            "ReceiverPhone": "13682229829",
            "ReceiverProvince": "广东省",
            "ReceiverCity": "广州市",
            "ReceiverAddress": "越秀区寺右南路17号702房",
            "Remark": "",
            "Kind": "shop",
            "ShipPrice": 0.00,
            "ReceiverPostalCode": 0.0,
            "OrderActions": null,
            "PackageStatus": 1,
            "ProductList": [
                {
                    "ProductSkuNo": "101814957601",
                    "SkuParamCode": "[]",
                    "Counter": 1,
                    "TotalPrice": 0.01,
                    "Kind": "shop",
                    "DeptCode": null,
                    "Remark": "手机号码-13682229829,",
                    "IsSpecaillyPrice": -1,
                    "UseDiscount": 0.0,
                    "IsHaveVCardPromotion": false,
                    "ShippingConfig": null,
                    "ShippingFee": 0.0,
                    "XinglianMinimumQty": null,
                    "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"/res/gdtvimg/20221018/c430292a159349c39574d830eddbaf1d.png\",\"FileName\":null,\"FileExt\":\"png\",\"ServerUrl\":\"https://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
                    "ProductName": "软游通测试产品",
                    "ProductNameTag": null,
                    "ProductNo": "101814957601",
                    "IsForSale": null,
                    "ShortDesc": "",
                    "ShortDescTag": null,
                    "SalePrice": 0.01,
                    "MarketPrice": 0.0,
                    "GroundingTime": "0001-01-01 00:00:00",
                    "Storage": 0,
                    "StorageStatus": 0,
                    "StartTime": null,
                    "EndTime": null,
                    "SellCount": 0,
                    "Status": null,
                    "IsVirtual": null,
                    "RemarkConfig": null,
                    "StoreId": 0,
                    "PackContent": null,
                    "GiftContent": null,
                    "TagIds": null,
                    "TagKind": null,
                    "IsShow": null,
                    "Video": null,
                    "TypePrefixStr": null,
                    "TypeId": 0,
                    "LimitConfig": null,
                    "Memo": null,
                    "FakeSellCount": 0,
                    "UpdateTime": "0001-01-01 00:00:00",
                    "IsRestrictBuy": null,
                    "CookBookList": null,
                    "IsFreeSample": null
                }
            ],
            "PackageList": [
                {
                    "ShipNo": "13682229829",
                    "FinishStatus": 0,
                    "Title": "包裹",
                    "OrderNo": "250106171927121588600",
                    "ShipType": "shentong",
                    "CancelStatus": 0,
                    "GiftList": "[]",
                    "ShippingName": "申通",
                    "PackageProduct": [
                        {
                            "ApplyStatus": null,
                            "SkuData": "[]",
                            "CanApply": 0,
                            "Counter": 1,
                            "ProductName": "软游通测试产品",
                            "ProductSummary": "",
                            "ProductNo": "101814957601",
                            "Remark": "手机号码-13682229829,",
                            "ProductImage": "[{\"FileId\":0,\"FilePath\":\"/res/gdtvimg/20221018/c430292a159349c39574d830eddbaf1d.png\",\"FileName\":null,\"FileExt\":\"png\",\"ServerUrl\":\"https://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
                            "SkuProductNo": "101814957601",
                            "PackageNo": "2501061719271215886000001"
                        },
                    ],
                    "ShipStatus": 1,
                    "PackageNo": "2501061719271215886000001"
                },
                {
                    "ShipNo": "13682229830",
                    "FinishStatus": 0,
                    "Title": "包裹",
                    "OrderNo": "250106171927121588600",
                    "ShipType": "shentong",
                    "CancelStatus": 0,
                    "GiftList": "[]",
                    "ShippingName": "申通",
                    "PackageProduct": [
                        {
                            "ApplyStatus": null,
                            "SkuData": "[]",
                            "CanApply": 0,
                            "Counter": 1,
                            "ProductName": "软游通测试产品",
                            "ProductSummary": "",
                            "ProductNo": "101814957601",
                            "Remark": "手机号码-13682229829,",
                            "ProductImage": "[{\"FileId\":0,\"FilePath\":\"/res/gdtvimg/20221018/c430292a159349c39574d830eddbaf1d.png\",\"FileName\":null,\"FileExt\":\"png\",\"ServerUrl\":\"https://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
                            "SkuProductNo": "101814957601",
                            "PackageNo": "2501061719271215886000001"
                        },
                    ],
                    "ShipStatus": 1,
                    "PackageNo": "2501061719271215886000002"
                }
            ],
            "GiftList": null,
            "SplitStatus": 9,
            "DiscountFee": 0.00,
            "ProducctFee": 0.01,
            "AppendStatus": "1",
            "DeptCode": "ryt",
            "IsVirtual": false,
            "CanAfterSale": false
        }
    }
},
'Member.CancelOrder':{
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 0,
    "Result": {
        "Data": {
            "Id": 1638095,
            "OrderNo": "250102174650121556800",
            "PaymentNo": "250102174650121556800_NATIVE",
            "PaymentTradeNo": null,
            "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
            "MemberName": null,
            "Phone": null,
            "DeleteStatus": "0",
            "CancelStatus": 1,
            "PayStatus": 0,
            "ShippingStatus": -9,
            "ShippingNo": null,
            "ShippingType": null,
            "FinishedStatus": 0,
            "ConfirmedStatus": 0,
            "CommentStatus": "0",
            "OrderTime": "2025-01-02 17:46:50",
            "TotalPrice": 45.86,
            "PaymentPrice": 45.86,
            "PaymentId": 3,
            "PaymentName": "WXPAY",
            "PaymentInterface": "微信支付",
            "ReceiverName": "周",
            "ReceiverPhone": "13682229829",
            "ReceiverProvince": "广东省",
            "ReceiverCity": "广州市",
            "ReceiverAddress": "越秀区麓苑路51号三荣大厦商务中心413",
            "Remark": "",
            "Kind": "shop",
            "ShipPrice": 0.00,
            "ReceiverPostalCode": 0.0,
            "OrderActions": null,
            "PackageStatus": 0,
            "ProductList": [
                {
                    "ProductSkuNo": "070112255601_26670_",
                    "SkuParamCode": "[{\"GroupId\":9819,\"GroupName\":\"规格\",\"ItemId\":26670,\"ItemName\":\"1080克一箱装\"}]",
                    "Counter": 1,
                    "TotalPrice": 59.90,
                    "Kind": "shop",
                    "DeptCode": null,
                    "Remark": null,
                    "IsSpecaillyPrice": -1,
                    "UseDiscount": 0.0,
                    "IsHaveVCardPromotion": false,
                    "ShippingConfig": null,
                    "ShippingFee": 0.0,
                    "XinglianMinimumQty": null,
                    "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"/res/gdtvimg/20240701/916147cc52c64607925a1405f657021a.jpg\",\"FileName\":null,\"FileExt\":\"jpg\",\"ServerUrl\":\"https://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
                    "ProductName": "怀府街 铁棍山药麻花礼盒包装休闲零食 口口香脆酥香不腻1080g/箱",
                    "ProductNameTag": null,
                    "ProductNo": "070112255601",
                    "IsForSale": null,
                    "ShortDesc": "脾胃食养新宠 ≥35％新鲜铁棍山药\n不含反式脂肪酸\n精选原材 口口酥香\n传统手艺 匠心精制\n礼盒包装，送礼送美味\n清欢至味 最是诱人",
                    "ShortDescTag": null,
                    "SalePrice": 59.90,
                    "MarketPrice": 0.0,
                    "GroundingTime": "0001-01-01 00:00:00",
                    "Storage": 0,
                    "StorageStatus": 0,
                    "StartTime": null,
                    "EndTime": null,
                    "SellCount": 0,
                    "Status": null,
                    "IsVirtual": null,
                    "RemarkConfig": null,
                    "StoreId": 0,
                    "PackContent": null,
                    "GiftContent": null,
                    "TagIds": null,
                    "TagKind": null,
                    "IsShow": null,
                    "Video": null,
                    "TypePrefixStr": null,
                    "TypeId": 0,
                    "LimitConfig": null,
                    "Memo": null,
                    "FakeSellCount": 0,
                    "UpdateTime": "0001-01-01 00:00:00",
                    "IsRestrictBuy": null,
                    "CookBookList": null,
                    "IsFreeSample": null
                }
            ],
            "PackageList": null,
            "GiftList": null,
            "SplitStatus": 0,
            "DiscountFee": 14.04,
            "ProducctFee": 59.90,
            "AppendStatus": "1",
            "DeptCode": "",
            "IsVirtual": false,
            "CanAfterSale": false
        }
    }
  },
'Member.CancelOrder':{
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 0,
    "Result": {
        "Data": 0
    }
},
'Member.LoadAddressList':{
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 10,
    "Result": {
        "List": [
            {
                "Id": 544094,
                "Receiver": "周先生",
                "Status": "0",
                "Address": "朝阳路1号，中国传媒大学北区公寓快递柜",
                "Phone": "13250261704",
                "ProvinceCode": "110000",
                "ProvinceName": "北京",
                "CityCode": "110100",
                "CityName": "北京城区",
                "AreaCode": "110105",
                "AreaName": "朝阳区",
                "PostCode": null
            },
            {
                "Id": 536091,
                "Receiver": "周",
                "Status": "1",
                "Address": "麓苑路51号三荣大厦商务中心413",
                "Phone": "13682229829",
                "ProvinceCode": "440000",
                "ProvinceName": "广东省",
                "CityCode": "440100",
                "CityName": "广州市",
                "AreaCode": "440104",
                "AreaName": "越秀区",
                "PostCode": null
            },
            {
                "Id": 539140,
                "Receiver": "周",
                "Status": "0",
                "Address": "寺右南路17号702房",
                "Phone": "13682229829",
                "ProvinceCode": "440000",
                "ProvinceName": "广东省",
                "CityCode": "440100",
                "CityName": "广州市",
                "AreaCode": "440104",
                "AreaName": "越秀区",
                "PostCode": null
            },
            {
                "Id": 540264,
                "Receiver": "陈先生",
                "Status": "0",
                "Address": "东华北路168号金城大厦2号楼，重本紫藤后门货架",
                "Phone": "13112244598",
                "ProvinceCode": "440000",
                "ProvinceName": "广东省",
                "CityCode": "440100",
                "CityName": "广州市",
                "AreaCode": "440104",
                "AreaName": "越秀区",
                "PostCode": null
            },
            {
                "Id": 542403,
                "Receiver": "刘先生",
                "Status": "0",
                "Address": "华乐街道青龙坊112号（市场监管局）",
                "Phone": "13682229829",
                "ProvinceCode": "440000",
                "ProvinceName": "广东省",
                "CityCode": "440100",
                "CityName": "广州市",
                "AreaCode": "440104",
                "AreaName": "越秀区",
                "PostCode": null
            },
            {
                "Id": 539185,
                "Receiver": "何小姐",
                "Status": "0",
                "Address": "华夏路26号雅居乐中心6楼中行人力",
                "Phone": "13682229830",
                "ProvinceCode": "440000",
                "ProvinceName": "广东省",
                "CityCode": "440100",
                "CityName": "广州市",
                "AreaCode": "440106",
                "AreaName": "天河区",
                "PostCode": null
            },
            {
                "Id": 540283,
                "Receiver": "马小姐",
                "Status": "0",
                "Address": "临江大道59号天銮A5-3602",
                "Phone": "13808888797",
                "ProvinceCode": "440000",
                "ProvinceName": "广东省",
                "CityCode": "440100",
                "CityName": "广州市",
                "AreaCode": "440106",
                "AreaName": "天河区",
                "PostCode": null
            },
            {
                "Id": 538137,
                "Receiver": "罗小姐",
                "Status": "0",
                "Address": "广州市白云区金沙洲悦峰三街262号万科爱地住区丰巢柜",
                "Phone": "15521382931",
                "ProvinceCode": "440000",
                "ProvinceName": "广东省",
                "CityCode": "440100",
                "CityName": "广州市",
                "AreaCode": "440111",
                "AreaName": "白云区",
                "PostCode": null
            },
            {
                "Id": 543627,
                "Receiver": "郭先生",
                "Status": "",
                "Address": "雅居乐花园灏湖居131号",
                "Phone": "13602868807",
                "ProvinceCode": "440000",
                "ProvinceName": "广东省",
                "CityCode": "440100",
                "CityName": "广州市",
                "AreaCode": "440113",
                "AreaName": "番禺区",
                "PostCode": null
            },
            {
                "Id": 540283,
                "Receiver": "马小姐",
                "Status": "0",
                "Address": "临江大道59号天銮A5-3602",
                "Phone": "13808888797",
                "ProvinceCode": "440000",
                "ProvinceName": "广东省",
                "CityCode": "440100",
                "CityName": "广州市",
                "AreaCode": "440106",
                "AreaName": "天河区",
                "PostCode": null
            },
            {
                "Id": 538137,
                "Receiver": "罗小姐",
                "Status": "0",
                "Address": "广州市白云区金沙洲悦峰三街262号万科爱地住区丰巢柜",
                "Phone": "15521382931",
                "ProvinceCode": "440000",
                "ProvinceName": "广东省",
                "CityCode": "440100",
                "CityName": "广州市",
                "AreaCode": "440111",
                "AreaName": "白云区",
                "PostCode": null
            },
            {
                "Id": 543627,
                "Receiver": "郭先生",
                "Status": "",
                "Address": "雅居乐花园灏湖居131号",
                "Phone": "13602868807",
                "ProvinceCode": "440000",
                "ProvinceName": "广东省",
                "CityCode": "440100",
                "CityName": "广州市",
                "AreaCode": "440113",
                "AreaName": "番禺区",
                "PostCode": null
            }
        ]
    }
},
'Member.LoadAddressDetail':{
"ErrorCode": "0000",
"Error": false,
"ErrorMsg": "操作成功",
"TotalCount": 0,
"Result": {
    "Data": {
        "Id": 544094,
        "Receiver": "周先生",
        "Status": "0",
        "Address": "朝阳路1号，中国传媒大学北区公寓快递柜",
        "Phone": "13250261704",
        "ProvinceCode": "110000",
        "ProvinceName": "北京",
        "CityCode": "110100",
        "CityName": "北京城区",
        "AreaCode": "110105",
        "AreaName": "朝阳区",
        "PostCode": null
    }
}
},
'Pub.LoadAddress':{
"ErrorCode": "0000",
"Error": false,
"ErrorMsg": "操作成功",
"TotalCount": 0,
"Result": {
    "List": [
        {
            "Key": "110000",
            "Value": "北京"
        },
        {
            "Key": "120000",
            "Value": "天津"
        },
        {
            "Key": "130000",
            "Value": "河北省"
        },
        {
            "Key": "140000",
            "Value": "山西省"
        },
        {
            "Key": "310000",
            "Value": "上海"
        },
        {
            "Key": "320000",
            "Value": "江苏省"
        },
        {
            "Key": "330000",
            "Value": "浙江省"
        },
        {
            "Key": "340000",
            "Value": "安徽省"
        },
        {
            "Key": "350000",
            "Value": "福建省"
        },
        {
            "Key": "360000",
            "Value": "江西省"
        },
        {
            "Key": "370000",
            "Value": "山东省"
        },
        {
            "Key": "410000",
            "Value": "河南省"
        },
        {
            "Key": "420000",
            "Value": "湖北省"
        },
        {
            "Key": "430000",
            "Value": "湖南省"
        },
        {
            "Key": "440000",
            "Value": "广东省"
        },
        {
            "Key": "450000",
            "Value": "广西壮族自治区"
        },
        {
            "Key": "460000",
            "Value": "海南省"
        },
        {
            "Key": "500000",
            "Value": "重庆"
        },
        {
            "Key": "510000",
            "Value": "四川省"
        },
        {
            "Key": "520000",
            "Value": "贵州省"
        },
        {
            "Key": "530000",
            "Value": "云南省"
        },
        {
            "Key": "610000",
            "Value": "陕西省"
        },
        {
            "Key": "440100",
            "Value": "广州市"
        },
        {
            "Key": "440200",
            "Value": "韶关市"
        },
        {
            "Key": "440300",
            "Value": "深圳市"
        },
        {
            "Key": "440400",
            "Value": "珠海市"
        },
        {
            "Key": "440500",
            "Value": "汕头市"
        },
        {
            "Key": "440600",
            "Value": "佛山市"
        },
        {
            "Key": "440700",
            "Value": "江门市"
        },
        {
            "Key": "440800",
            "Value": "湛江市"
        },
        {
            "Key": "440900",
            "Value": "茂名市"
        },
        {
            "Key": "441200",
            "Value": "肇庆市"
        },
        {
            "Key": "441300",
            "Value": "惠州市"
        },
        {
            "Key": "441400",
            "Value": "梅州市"
        },
        {
            "Key": "441500",
            "Value": "汕尾市"
        },
        {
            "Key": "441600",
            "Value": "河源市"
        },
        {
            "Key": "441700",
            "Value": "阳江市"
        },
        {
            "Key": "441800",
            "Value": "清远市"
        },
        {
            "Key": "441900",
            "Value": "东莞市"
        },
        {
            "Key": "442000",
            "Value": "中山市"
        },
        {
            "Key": "445100",
            "Value": "潮州市"
        },
        {
            "Key": "445200",
            "Value": "揭阳市"
        },
        {
            "Key": "445300",
            "Value": "云浮市"
        },
        {
            "Key": "440103",
            "Value": "荔湾区"
        },
        {
            "Key": "440104",
            "Value": "越秀区"
        },
        {
            "Key": "440105",
            "Value": "海珠区"
        },
        {
            "Key": "440106",
            "Value": "天河区"
        },
        {
            "Key": "440111",
            "Value": "白云区"
        },
        {
            "Key": "440112",
            "Value": "黄埔区"
        },
        {
            "Key": "440113",
            "Value": "番禺区"
        },
        {
            "Key": "440114",
            "Value": "花都区"
        },
        {
            "Key": "440115",
            "Value": "南沙区"
        },
        {
            "Key": "440117",
            "Value": "从化区"
        },
        {
            "Key": "440118",
            "Value": "增城区"
        }
    ]
}
},
'Member.SaveAddress':{
"ErrorCode": "0000",
"Error": false,
"ErrorMsg": "操作成功",
"TotalCount": 0,
"Result": {
    "Data": {
        "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
        "Receiver": "留个脚印e",
        "Province": "440000",
        "City": "440100",
        "Area": "440103",
        "Address": "留个脚印信及豚鱼",
        "Phone": "13682229829",
        "PostCode": null,
        "Mobile": null,
        "Status": "",
        "Id": 545746
    }
}
},
'Member.RequirePayOrder':{
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 0,
    "Result": {}
    },
'Member.GetShippingInfo':{
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 0,
    "Result": {
        "Data": "{\"message\":\"ok\",\"nu\":\"YT2519423430802\",\"ischeck\":\"1\",\"com\":\"yuantong\",\"status\":\"200\",\"data\":[{\"time\":\"2025-01-06 17:41:59\",\"context\":\"您的快件已签收，签收人: 办公室门口。(有事先呼我，勿找平台，少一次投诉，多一份感恩）！如有疑问请联系快递员: 18033378337，网点电话：13672539970，投诉电话: 13672539970。感谢使用圆通速递，期待再次为您服务！\",\"ftime\":\"2025-01-06 17:41:59\",\"areaCode\":\"CN445302001000\",\"areaName\":\"广东,云浮市,云城区,云城\",\"status\":\"签收\"},{\"time\":\"2025-01-06 16:01:58\",\"context\":\"【广东省云浮市云城区安塘镇】的徐心灵（18033378337）正在派件，（有事先呼我，勿找平台，少一次投诉，多一份感恩）！如有疑问请联系网点:13672539970，投诉电话:13672539970。[95161和18521号段的上海号码为圆通快递员专属号码，请放心接听]\",\"ftime\":\"2025-01-06 16:01:58\",\"areaCode\":\"CN445302001000\",\"areaName\":\"广东,云浮市,云城区,云城\",\"status\":\"派件\"},{\"time\":\"2025-01-06 14:05:20\",\"context\":\"您的快件已经到达【广东省云浮市】\",\"ftime\":\"2025-01-06 14:05:20\",\"areaCode\":null,\"areaName\":null,\"status\":\"在途\"},{\"time\":\"2025-01-06 06:14:02\",\"context\":\"您的快件离开【广州转运中心】，已发往【广东省云浮市】\",\"ftime\":\"2025-01-06 06:14:02\",\"areaCode\":null,\"areaName\":null,\"status\":\"在途\"},{\"time\":\"2025-01-06 06:08:29\",\"context\":\"您的快件已经到达【广州转运中心】\",\"ftime\":\"2025-01-06 06:08:29\",\"areaCode\":null,\"areaName\":null,\"status\":\"在途\"},{\"time\":\"2025-01-05 02:10:31\",\"context\":\"您的快件离开【长治转运中心】，已发往【广州转运中心】。预计【01月06日】到达【广州市】，因运输距离较远，预计将在【06日晚上】为您更新快件状态，请您放心！\",\"ftime\":\"2025-01-05 02:10:31\",\"areaCode\":null,\"areaName\":null,\"status\":\"在途\"},{\"time\":\"2025-01-05 02:09:00\",\"context\":\"您的快件已经到达【长治转运中心】\",\"ftime\":\"2025-01-05 02:09:00\",\"areaCode\":null,\"areaName\":null,\"status\":\"在途\"},{\"time\":\"2025-01-04 17:49:01\",\"context\":\"您的快件离开【山西省运城市】，已发往【长治转运中心】\",\"ftime\":\"2025-01-04 17:49:01\",\"areaCode\":\"CN140802001000\",\"areaName\":\"山西,运城市,盐湖区,中城\",\"status\":\"在途\"},{\"time\":\"2025-01-03 15:10:59\",\"context\":\"您的快件在【山西省运城市】已揽收，揽收人: 陈慊（18503593355）\",\"ftime\":\"2025-01-03 15:10:59\",\"areaCode\":\"CN140802001000\",\"areaName\":\"山西,运城市,盐湖区,中城\",\"status\":\"揽收\"}],\"state\":\"3\",\"condition\":\"F00\"}"
    }
    },
'Member.LoadReturnablesDetail':{
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 0,
    "Result": {
        "Data": {
            "Id": 1638292,
            "OrderNo": "250106171927121588600",
            "PaymentNo": "250106171927121588600",
            "PaymentTradeNo": "4200002454202501066074921625",
            "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
            "MemberName": null,
            "Phone": null,
            "DeleteStatus": "0",
            "CancelStatus": 0,
            "PayStatus": 1,
            "ShippingStatus": 1,
            "ShippingNo": "13682229829",
            "ShippingType": "shentong",
            "FinishedStatus": 0,
            "ConfirmedStatus": 1,
            "CommentStatus": "0",
            "OrderTime": "2025-01-06 17:19:27",
            "TotalPrice": 0.01,
            "PaymentPrice": 0.01,
            "PaymentId": 3,
            "PaymentName": null,
            "PaymentInterface": null,
            "ReceiverName": "周",
            "ReceiverPhone": "13682229829",
            "ReceiverProvince": "广东省",
            "ReceiverCity": "广州市",
            "ReceiverAddress": "越秀区寺右南路17号702房",
            "Remark": "",
            "Kind": "shop",
            "ShipPrice": 0.00,
            "ReceiverPostalCode": 0.0,
            "OrderActions": null,
            "PackageStatus": 1,
            "ProductList": [
                {
                    "ProductSkuNo": "101814957601",
                    "SkuParamCode": "[]",
                    "Counter": 1,
                    "TotalPrice": 0.01,
                    "Kind": "shop",
                    "DeptCode": null,
                    "Remark": "手机号码-13682229829,",
                    "IsSpecaillyPrice": 0,
                    "UseDiscount": 0.0,
                    "IsHaveVCardPromotion": false,
                    "ShippingConfig": null,
                    "ShippingFee": 0.0,
                    "XinglianMinimumQty": null,
                    "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"/res/gdtvimg/20221018/c430292a159349c39574d830eddbaf1d.png\",\"FileName\":null,\"FileExt\":\"png\",\"ServerUrl\":\"https://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
                    "ProductName": "软游通测试产品",
                    "ProductNameTag": null,
                    "ProductNo": "101814957601",
                    "IsForSale": null,
                    "ShortDesc": "",
                    "ShortDescTag": null,
                    "SalePrice": 0.01,
                    "MarketPrice": 0.0,
                    "GroundingTime": "0001-01-01 00:00:00",
                    "Storage": 0,
                    "StorageStatus": 0,
                    "StartTime": null,
                    "EndTime": null,
                    "SellCount": 0,
                    "Status": null,
                    "IsVirtual": null,
                    "RemarkConfig": null,
                    "StoreId": 0,
                    "PackContent": null,
                    "GiftContent": null,
                    "TagIds": null,
                    "TagKind": null,
                    "IsShow": null,
                    "Video": null,
                    "TypePrefixStr": null,
                    "TypeId": 0,
                    "LimitConfig": null,
                    "Memo": null,
                    "FakeSellCount": 0,
                    "UpdateTime": "0001-01-01 00:00:00",
                    "IsRestrictBuy": null,
                    "CookBookList": null,
                    "IsFreeSample": null
                }
            ],
            "PackageList": null,
            "GiftList": null,
            "SplitStatus": 9,
            "DiscountFee": 0.0,
            "ProducctFee": 0.0,
            "AppendStatus": null,
            "DeptCode": "ryt",
            "IsVirtual": false,
            "CanAfterSale": false
        },
        "ReasonList": [
            {
                "Key": "11",
                "Value": "签收后对商品不满意"
            },
            {
                "Key": "12",
                "Value": "签收后对物流不满意"
            },
            {
                "Key": "13",
                "Value": "发货后物流异常"
            }
        ]
    }
    },
'Member.LoadReturnablesDetail':{
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 0,
    "Result": {
        "Data": {
            "Id": 1638292,
            "OrderNo": "250106171927121588600",
            "PaymentNo": "250106171927121588600",
            "PaymentTradeNo": "4200002454202501066074921625",
            "MemberAccount": "5ecaf32892a248caba0c622a22c5448e",
            "MemberName": null,
            "Phone": null,
            "DeleteStatus": "0",
            "CancelStatus": 0,
            "PayStatus": 1,
            "ShippingStatus": 1,
            "ShippingNo": "13682229829",
            "ShippingType": "shentong",
            "FinishedStatus": 0,
            "ConfirmedStatus": 1,
            "CommentStatus": "0",
            "OrderTime": "2025-01-06 17:19:27",
            "TotalPrice": 0.01,
            "PaymentPrice": 0.01,
            "PaymentId": 3,
            "PaymentName": null,
            "PaymentInterface": null,
            "ReceiverName": "周",
            "ReceiverPhone": "13682229829",
            "ReceiverProvince": "广东省",
            "ReceiverCity": "广州市",
            "ReceiverAddress": "越秀区寺右南路17号702房",
            "Remark": "",
            "Kind": "shop",
            "ShipPrice": 0.00,
            "ReceiverPostalCode": 0.0,
            "OrderActions": null,
            "PackageStatus": 1,
            "ProductList": [
                {
                    "ProductSkuNo": "101814957601",
                    "SkuParamCode": "[]",
                    "Counter": 1,
                    "TotalPrice": 0.01,
                    "Kind": "shop",
                    "DeptCode": null,
                    "Remark": "手机号码-13682229829,",
                    "IsSpecaillyPrice": 0,
                    "UseDiscount": 0.0,
                    "IsHaveVCardPromotion": false,
                    "ShippingConfig": null,
                    "ShippingFee": 0.0,
                    "XinglianMinimumQty": null,
                    "ThumbnailImg": "[{\"FileId\":0,\"FilePath\":\"/res/gdtvimg/20221018/c430292a159349c39574d830eddbaf1d.png\",\"FileName\":null,\"FileExt\":\"png\",\"ServerUrl\":\"https://imgsrc.gdtvdv.com\",\"SplitList\":null}]",
                    "ProductName": "软游通测试产品",
                    "ProductNameTag": null,
                    "ProductNo": "101814957601",
                    "IsForSale": null,
                    "ShortDesc": "",
                    "ShortDescTag": null,
                    "SalePrice": 0.01,
                    "MarketPrice": 0.0,
                    "GroundingTime": "0001-01-01 00:00:00",
                    "Storage": 0,
                    "StorageStatus": 0,
                    "StartTime": null,
                    "EndTime": null,
                    "SellCount": 0,
                    "Status": null,
                    "IsVirtual": null,
                    "RemarkConfig": null,
                    "StoreId": 0,
                    "PackContent": null,
                    "GiftContent": null,
                    "TagIds": null,
                    "TagKind": null,
                    "IsShow": null,
                    "Video": null,
                    "TypePrefixStr": null,
                    "TypeId": 0,
                    "LimitConfig": null,
                    "Memo": null,
                    "FakeSellCount": 0,
                    "UpdateTime": "0001-01-01 00:00:00",
                    "IsRestrictBuy": null,
                    "CookBookList": null,
                    "IsFreeSample": null
                }
            ],
            "PackageList": null,
            "GiftList": null,
            "SplitStatus": 9,
            "DiscountFee": 0.0,
            "ProducctFee": 0.0,
            "AppendStatus": null,
            "DeptCode": "ryt",
            "IsVirtual": false,
            "CanAfterSale": false
        },
        "ReasonList": [
            {
                "Key": "11",
                "Value": "签收后对商品不满意"
            },
            {
                "Key": "12",
                "Value": "签收后对物流不满意"
            },
            {
                "Key": "13",
                "Value": "发货后物流异常"
            }
        ]
    }
    },
'Member.ApplyReturnProduct':{
    "ErrorCode": "0000",
    "Error": false,
    "ErrorMsg": "操作成功",
    "TotalCount": 0,
    "Result": {}
    },
'PostReason':{
    "d": [
        {
            "__type": "DotNet.Common.TransferParam.ParamKeyValuePair",
            "Key": "35",
            "Value": "产品损坏"
        },
        {
            "__type": "DotNet.Common.TransferParam.ParamKeyValuePair",
            "Key": "36",
            "Value": "成熟度不够"
        },
        {
            "__type": "DotNet.Common.TransferParam.ParamKeyValuePair",
            "Key": "48",
            "Value": "产品漏发"
        }
    ]
}
}; 